import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NotificationType } from 'src/app/modules/general/models/notification-type';
import { NotificationService } from 'src/app/modules/general/services/notification.service';
import { OrderStateService } from 'src/app/modules/order/services/order-state.service';
import { Order } from '../../../order/models/order';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent implements OnInit, OnDestroy {

  @Input()
  order: Order;

  @Output()
  continueShopping = new EventEmitter();

  @ViewChild(NgForm, { static: false}) form: NgForm;

  email: string;

  private sendGuestOrderToEmailSubscription: Subscription;

  constructor(
    private orderStateService: OrderStateService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeSendGuestOrderToEmail();
    this.notificationService.hide(PaymentResultComponent.name);
  }

  onClickContinueShopping(): void {
    this.continueShopping.emit();
  }

  get isGuest(): boolean {
    return !!this.order?.guestOrderKey;
  }

  get downloadInvoiceUrl(): string {
    return this.order?.invoiceUrl;
  }

  get downloadTicketsUrl(): string {
    return this.order?.ticketUrl;
  }

  get downloadGiftCardsUrl(): string {
    return this.order?.giftcardUrl;
  }

  onSendByEmail(): void {
    this._unsubscribeSendGuestOrderToEmail();
    this.sendGuestOrderToEmailSubscription = this.orderStateService.sendGuestOrderToEmail(this.email)
      .subscribe(
        result => {
          if (result) {
            this.notificationService.show(PaymentResultComponent.name, 'Email sent', NotificationType.Success);
          } else {
            this.notificationService.show(PaymentResultComponent.name, 'Email not sent', NotificationType.Error);
          }
        },
        error => {
          const errorMessage = error?.message || error || 'Error';
          this.notificationService.show(PaymentResultComponent.name, errorMessage, NotificationType.Error);
        }
      );
  }

  private _unsubscribeSendGuestOrderToEmail(): void {
    if (this.sendGuestOrderToEmailSubscription) {
      this.sendGuestOrderToEmailSubscription.unsubscribe();
      this.sendGuestOrderToEmailSubscription = null;
    }
  }

  get isFormValid(): boolean {
    return this.form?.valid;
  }

}
